import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class TestSeries extends Component {
  state = {
    secondaryCategories: [],
    per_page: 20,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      totalDocs: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
    notiColor: "success",
    notification: false,
    message: "",
    loading: false,
    updatingStatusId: "",
    filters: {
      search: "",
      active_status: "",
      stage: "",
      type: "",
      payment_type: "",
      date_from: "",
      date_to: "",
    },
  };
  componentDidMount() {
    this.getAllTestSeries(this.state.page_no, this.state.per_page);
  }

  getAllTestSeries = (page = this.state.page_no, limit = this.state.per_page) => {
    this.setState({ loading: true });
    if (init() === "success") {
      const { filters } = this.state;
      axios
        .get(Constants.getUrls.getAllTestSeries, {
          params: {
            page,
            limit,
            search: filters.search || undefined,
            active_status: filters.active_status || undefined,
            stage: filters.stage || undefined,
            type: filters.type || undefined,
            payment_type: filters.payment_type || undefined,
            date_from: filters.date_from || undefined,
            date_to: filters.date_to || undefined,
          },
        })
        .then((resp) => {
          const payload = resp?.data?.data || {};
          this.setState({
            secondaryCategories: payload.docs || [],
            page_no: payload.page || page,
            per_page: payload.limit || limit,
            pagination: {
              page: payload.page || page,
              totalPages: payload.totalPages || 1,
              totalDocs: payload.totalDocs || 0,
              hasNextPage: Boolean(payload.hasNextPage),
              hasPrevPage: Boolean(payload.hasPrevPage),
            },
            loading: false,
            updatingStatusId: "",
          });
        })
        .catch((err) => {
          this.setState({
            notiColor: "warning",
            message: "Something went wrong!",
            notification: true,
            updatingStatusId: "",
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
              notiColor: "success",
              loading: false,
            });
          }, 3500);
        });
    } else {
      this.setState({
        loading: false,
      });
    }
  };

  updateTestSeriesStatus = (testseriesId, test_series_status) => {
    if (init() !== "success") {
      return;
    }

    this.setState({ updatingStatusId: testseriesId });

    axios
      .put(`${Constants.putUrls.updateTestSeriesStatus}${testseriesId}`, {
        test_series_status,
      })
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp?.data?.message || "Test series status updated successfully.",
          },
          () => {
            this.getAllTestSeries(this.state.page_no, this.state.per_page);
          }
        );
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "error",
          message:
            err?.response?.data?.message || "Unable to update test series status.",
          updatingStatusId: "",
        });
      });

    setTimeout(() => {
      this.setState({
        notification: false,
        message: "",
      });
    }, 2500);
  };

  updateTestSeriesActiveStatus = (testseriesId, status) => {
    if (init() !== "success") {
      return;
    }

    this.setState({ updatingStatusId: testseriesId });

    axios
      .put(`${Constants.putUrls.updateTestSeriesStatus}${testseriesId}`, { status })
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp?.data?.message || "Active status updated successfully.",
          },
          () => {
            this.getAllTestSeries(this.state.page_no, this.state.per_page);
          }
        );
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "error",
          message: err?.response?.data?.message || "Unable to update active status.",
          updatingStatusId: "",
        });
      });

    setTimeout(() => {
      this.setState({
        notification: false,
        message: "",
      });
    }, 2500);
  };

  handleDelete = (id) => {
    if (!window.confirm("Delete this test series? This will be a soft delete.")) {
      return;
    }

    if (init() !== "success") {
      return;
    }

    axios
      .delete(`${Constants.deleteUrls.deleteTestSeries}${id}`)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp?.data?.message || "Test series deleted successfully.",
          },
          () => {
            const nextPage =
              this.state.secondaryCategories.length === 1 && this.state.page_no > 1
                ? this.state.page_no - 1
                : this.state.page_no;
            this.getAllTestSeries(nextPage, this.state.per_page);
          }
        );
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "error",
          message: err?.response?.data?.message || "Unable to delete test series.",
        });
      });

    setTimeout(() => {
      this.setState({
        notification: false,
        message: "",
      });
    }, 2500);
  };

  handleFilterInput = (key, value) => {
    this.setState((prev) => ({
      filters: {
        ...prev.filters,
        [key]: value,
      },
    }));
  };

  applyFilters = () => {
    this.getAllTestSeries(1, this.state.per_page);
  };

  resetFilters = () => {
    this.setState(
      {
        filters: {
          search: "",
          active_status: "",
          stage: "",
          type: "",
          payment_type: "",
          date_from: "",
          date_to: "",
        },
      },
      () => this.getAllTestSeries(1, this.state.per_page)
    );
  };

  handlePageChange = (page) => {
    this.getAllTestSeries(page, this.state.per_page);
  };

  handleEntriesPerPageChange = (limit) => {
    this.getAllTestSeries(1, limit);
  };

  render() {
    const { filters, pagination } = this.state;
    const filterFieldSx = {
      "& .MuiOutlinedInput-root": {
        minHeight: 56,
        borderRadius: "16px",
        backgroundColor: "#ffffff",
        transition: "all 180ms ease",
        "& fieldset": {
          borderColor: "rgba(24,53,38,0.14)",
        },
        "&:hover fieldset": {
          borderColor: "rgba(24,53,38,0.28)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#1f4c35",
          borderWidth: "1px",
          boxShadow: "0 0 0 4px rgba(31, 76, 53, 0.08)",
        },
      },
      "& .MuiInputLabel-root": {
        color: "#5b6f63",
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: "#1f4c35",
      },
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        minHeight: "56px",
        paddingTop: "0px",
        paddingBottom: "0px",
      },
      "& .MuiInputBase-input": {
        color: "#183526",
        fontSize: "0.95rem",
      },
    };

    return (
      <div>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Test Series
                </MDTypography>
              </MDBox>
              <Grid item sm={12} px={2} py={2} align="right">
                <Link to="/addTestseries">
                  <MDButton variant="contained" size="small" color="primary" sx={{ mr: 1 }}>
                    Create Scheduled
                  </MDButton>
                </Link>
                <Link to="/addMockTestseries">
                  <MDButton variant="outlined" size="small" color="info">
                    Create Mock
                  </MDButton>
                </Link>
              </Grid>
              <MDBox px={2} pb={1}>
                <Card
                  sx={{
                    border: "1px solid rgba(24,53,38,0.08)",
                    boxShadow: "0px 18px 44px rgba(18, 43, 29, 0.06)",
                    overflow: "hidden",
                  }}
                >
                  <MDBox
                    px={2.5}
                    py={2}
                    sx={{
                      background:
                        "linear-gradient(135deg, rgba(248,252,244,1) 0%, rgba(236,246,228,0.92) 100%)",
                      borderBottom: "1px solid rgba(24,53,38,0.08)",
                    }}
                  >
                    <MDTypography variant="h6">Filter Test Series</MDTypography>
                    <MDTypography variant="button" color="text">
                      Filter by active status, lifecycle stage, type, payment, name, and created date.
                    </MDTypography>
                  </MDBox>
                  <MDBox p={2.5}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={3}>
                        <TextField
                          fullWidth
                          label="Search by Name"
                          value={filters.search}
                          onChange={(e) => this.handleFilterInput("search", e.target.value)}
                          sx={filterFieldSx}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <FormControl fullWidth sx={filterFieldSx}>
                          <InputLabel>Active</InputLabel>
                          <Select
                            label="Active"
                            value={filters.active_status}
                            onChange={(e) =>
                              this.handleFilterInput("active_status", e.target.value)
                            }
                          >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="inactive">Inactive</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <FormControl fullWidth sx={filterFieldSx}>
                          <InputLabel>Status</InputLabel>
                          <Select
                            label="Status"
                            value={filters.stage}
                            onChange={(e) => this.handleFilterInput("stage", e.target.value)}
                          >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="upcoming">Upcoming</MenuItem>
                            <MenuItem value="live">Live</MenuItem>
                            <MenuItem value="mock">Mock</MenuItem>
                            <MenuItem value="completed">Completed</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <FormControl fullWidth sx={filterFieldSx}>
                          <InputLabel>Type</InputLabel>
                          <Select
                            label="Type"
                            value={filters.type}
                            onChange={(e) => this.handleFilterInput("type", e.target.value)}
                          >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="scheduled">Scheduled</MenuItem>
                            <MenuItem value="mock">Mock</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <FormControl fullWidth sx={filterFieldSx}>
                          <InputLabel>Payment</InputLabel>
                          <Select
                            label="Payment"
                            value={filters.payment_type}
                            onChange={(e) =>
                              this.handleFilterInput("payment_type", e.target.value)
                            }
                          >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="free">Free</MenuItem>
                            <MenuItem value="paid">Paid</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <TextField
                          fullWidth
                          label="Created From"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          value={filters.date_from}
                          onChange={(e) => this.handleFilterInput("date_from", e.target.value)}
                          sx={filterFieldSx}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <TextField
                          fullWidth
                          label="Created To"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          value={filters.date_to}
                          onChange={(e) => this.handleFilterInput("date_to", e.target.value)}
                          sx={filterFieldSx}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <MDBox display="flex" gap={1.5} flexWrap="wrap">
                          <MDButton variant="contained" color="info" onClick={this.applyFilters}>
                            Apply Filters
                          </MDButton>
                          <MDButton variant="outlined" color="secondary" onClick={this.resetFilters}>
                            Reset
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox py={3}>
                {this.state.loading ? (
                  <MDBox>
                    <Grid align="center">
                      <h4>Loading...</h4>
                    </Grid>
                  </MDBox>
                ) : (
                  <>
                    {this.state.secondaryCategories.length > 0 ? (
                      <DataTable
                        entriesPerPage={{
                          defaultValue: this.state.per_page,
                          entries: [10, 25, 50, 100],
                        }}
                        showTotalEntries
                        table={{
                          columns: [
                            { Header: "serial", accessor: "serial", width: "6%" },
                            { Header: "name", accessor: "test_series" },
                            { Header: "type", accessor: "type" },
                            { Header: "active", accessor: "active_status" },
                            { Header: "status", accessor: "status" },
                            // { Header: "email", accessor: "email" },
                            { Header: "poster", accessor: "small" },
                            {
                              Header: "seats",
                              accessor: "seats",
                            },
                            {
                              Header: "price",
                              accessor: "price",
                            },
                            {
                              Header: "offer price",
                              accessor: "offer_price",
                            },

                            // { Header: "jop_profile", accessor: "job_profile" },

                            // { Header: "file", accessor: "file" },
                            { Header: "action", accessor: "action" },
                          ],
                          rows: this.state.secondaryCategories.map((sec, index) => ({
                            serial: (this.state.page_no - 1) * this.state.per_page + index + 1,
                            test_series: sec?.test_series_name,
                            type: sec?.test_series_type || "scheduled",
                            active_status: (
                              <FormControl fullWidth size="small">
                                <InputLabel>Active</InputLabel>
                                <Select
                                  value={sec?.status || "inactive"}
                                  label="Active"
                                  disabled={this.state.updatingStatusId === sec?._id}
                                  onChange={(e) =>
                                    this.updateTestSeriesActiveStatus(sec?._id, e.target.value)
                                  }
                                  sx={{
                                    minWidth: 130,
                                    backgroundColor: "#ffffff",
                                    borderRadius: "12px",
                                  }}
                                >
                                  <MenuItem value="active">Active</MenuItem>
                                  <MenuItem value="inactive">Inactive</MenuItem>
                                </Select>
                              </FormControl>
                            ),
                            status: (
                              <FormControl fullWidth size="small">
                                <InputLabel>Status</InputLabel>
                                <Select
                                  value={
                                    sec?.test_series_type === "mock"
                                      ? sec?.test_series_status || "mock"
                                      : sec?.test_series_status || "upcoming"
                                  }
                                  label="Status"
                                  disabled={this.state.updatingStatusId === sec?._id}
                                  onChange={(e) =>
                                    this.updateTestSeriesStatus(sec?._id, e.target.value)
                                  }
                                  sx={{
                                    minWidth: 150,
                                    backgroundColor: "#ffffff",
                                    borderRadius: "12px",
                                  }}
                                >
                                  {sec?.test_series_type === "mock" ? (
                                    [
                                      <MenuItem value="mock" key="mock">
                                        Mock
                                      </MenuItem>,
                                      <MenuItem value="live" key="live">
                                        Live
                                      </MenuItem>,
                                      <MenuItem value="completed" key="completed">
                                        Completed
                                      </MenuItem>,
                                    ]
                                  ) : (
                                    [
                                      <MenuItem value="upcoming" key="upcoming">
                                        Upcoming
                                      </MenuItem>,
                                      <MenuItem value="live" key="live">
                                        Live
                                      </MenuItem>,
                                      <MenuItem value="completed" key="completed">
                                        Completed
                                      </MenuItem>,
                                    ]
                                  )}
                                </Select>
                              </FormControl>
                            ),
                            // email: sec.email,
                            small: (
                              <>
                                <img
                                  src={Constants.imageDomain + sec.small_poster}
                                  style={{ height: "100px", width: "250px" }}
                                />
                              </>
                            ),
                            seats: sec?.seats,
                            price: "₹ " + sec?.price,
                            offer_price: "₹ " + sec?.offer_price,
                            // job_profile: sec?.career_id?.career,
                            // file: <a href={"https://core.plantbae.in" + sec?.resume}> See File </a>,
                            // status: (
                            //   <>
                            //     <FormControl fullWidth>
                            //       <InputLabel>Application Status</InputLabel>
                            //       <Select
                            //         value={sec?.response_status}
                            //         onChange={(e) => this.applicationStatus(sec.id, e.target.value)}
                            //         label="Application Status"
                            //         name="response_status"
                            //         style={{
                            //           height: "45px",
                            //           color: "red",
                            //         }}
                            //       >
                            //         <MenuItem value="pending">Pending</MenuItem>
                            //         <MenuItem value="hired">Hired</MenuItem>
                            //         <MenuItem value="rejected">Rejected</MenuItem>
                            //       </Select>
                            //     </FormControl>
                            //   </>
                            // ),
                            action: (
                              <>
                                <div style={{ marginBottom: "0.75rem" }}>
                                  <Link to={`/testseries-leaderboard/${sec._id}`}>
                                    <MDButton
                                      variant="contained"
                                      size="small"
                                      color="success"
                                      sx={{ mr: 1, mb: 1 }}
                                    >
                                      Leaderboard
                                    </MDButton>
                                  </Link>
                                  <Link
                                    to={`/addNotification?testseries_id=${
                                      sec._id
                                    }&testseries_name=${encodeURIComponent(
                                      sec?.test_series_name || ""
                                    )}`}
                                  >
                                    <MDButton variant="contained" size="small" color="warning">
                                      Send Notification
                                    </MDButton>
                                  </Link>
                                </div>
                                {sec?.test_series_type === "mock" ? (
                                  <Link
                                    to={{
                                      pathname: "/update-mock-testseries/" + sec._id,
                                      state: { data: sec },
                                    }}
                                  >
                                    <MDButton
                                      variant="outlined"
                                      size="small"
                                      color="secondary"
                                      sx={{ mr: 1 }}
                                    >
                                      Edit
                                    </MDButton>
                                  </Link>
                                ) : (
                                  <Link
                                    to={{
                                      pathname: "/update-scheduled-testseries/" + sec._id,
                                      state: { data: sec },
                                    }}
                                  >
                                    <MDButton
                                      variant="outlined"
                                      size="small"
                                      color="secondary"
                                      sx={{ mr: 1 }}
                                    >
                                      Edit
                                    </MDButton>
                                  </Link>
                                )}
                                {sec?.test_series_type === "mock" ? (
                                  <Link
                                    to={{
                                      pathname: "/import-mock-test-questions/" + sec._id,
                                      state: { data: sec },
                                    }}
                                  >
                                    <MDButton variant="outlined" size="small" color="info">
                                      Import Questions
                                    </MDButton>
                                  </Link>
                                ) : (
                                  <Link
                                    to={{
                                      pathname: "/allot-questions/" + sec._id,
                                      state: { data: sec },
                                    }}
                                    >
                                      <MDButton variant="outlined" size="small" color="success">
                                        Allot Question
                                      </MDButton>
                                    </Link>
                                )}
                                <div style={{ marginTop: "0.75rem" }}>
                                  <MDButton
                                    variant="outlined"
                                    size="small"
                                    color="error"
                                    onClick={() => this.handleDelete(sec?._id)}
                                  >
                                    Delete
                                  </MDButton>
                                </div>
                              </>
                            ),
                          })),
                        }}
                        page_no={pagination?.page}
                        totalPages={pagination?.totalPages}
                        totalDocs={pagination?.totalDocs}
                        hasNextPage={pagination?.hasNextPage}
                        hasPrevPage={pagination?.hasPrevPage}
                        isnextPage={pagination?.page + 1}
                        prevPage={Math.max((pagination?.page || 1) - 1, 1)}
                        onPageChange={this.handlePageChange}
                        onEntriesPerPageChange={this.handleEntriesPerPageChange}
                      />
                    ) : (
                      <div>No Data Found!</div>
                    )}
                  </>
                )}
              </MDBox>
              <>
                <MDSnackbar
                  color={this.state.notiColor}
                  icon="notifications"
                  title="Agriquiz"
                  content={this.state.message}
                  dateTime="Just now"
                  open={this.state.notification}
                  //   close={toggleSnackbar}
                />
              </>
            </Card>
          </MDBox>
        </DashboardLayout>
      </div>
    );
  }
}
